import { DestinationTimingKbn, EmailClass } from "../../assets/data/Constants";
import { labelids } from "../../assets/data/TkExplanationProperty";
import { ITkFakeTableLineProps } from "../../type/componentsType/TkFakeTableLine";
import { TkGetCodeList } from "../../utils/TkGetCode";
import TkPropertyMessageGet from "../../utils/TkPropertyMessageGet";

const tableList: ITkFakeTableLineProps[] = [
  {
    keyword: "info",
    type: "explanatoryText",
    explanatoryText: labelids.labelid.LBLW140003_01,
  },
  {
    title: "メール種別",
    keyword: "emailClass",
    type: "selectForm",
    selectPropsList: TkGetCodeList(EmailClass),
    disabled: true,
  },
  // {
  //   title: "宛先１",
  //   keyword: "address1",
  //   type: "radio",
  //   radioPropsList: TkGetCodeList(Address1),
  //   requiredIcon: true,
  // },
  // {
  //   title: "宛先２",
  //   keyword: "address2",
  //   type: "nodeInLine",
  //   requiredIcon: true,
  //   helpicon: true,
  //   helpText: (
  //     <>
  //       宛先１にて「既存の宛先を選択」を選択した場合は、宛先２は選択プルダウンから選択してください。
  //       <br />
  //       宛先１にて「個別に宛先を指定」を選択した場合は、宛先２はメールアドレス・共済契約者番号を入力してください。
  //     </>
  //   ),
  // },
  // {
  //   title: "手続き名",
  //   keyword: "procedureName",
  //   type: "selectForm",
  //   selectPropsList: TkGetCodeList(ProcedureTemplate),
  //   requiredIcon: true,
  // },
  {
    title: "テンプレート名",
    keyword: "tempName",
    requiredIcon: true,
    inputProps: { maxLength: 85 },
  },
  {
    title: "タイトル",
    keyword: "title",
    requiredIcon: true,
    inputProps: { maxLength: 85 },
    disabled: true,
  },
  {
    title: "本文",
    keyword: "text",
    type: "textarea",
    requiredIcon: true,
    inputProps: { maxLength: 1000 },
    disabled: true,
  },
  {
    title: "送信タイミング１",
    keyword: "destinationTiming1",
    type: "radio",
    radioPropsList: TkGetCodeList(DestinationTimingKbn),
    showLine: false,
  },
  {
    title: "送信タイミング２（※99は月末）",
    keyword: "destinationTiming2",
    type: "nodeInLine",
    showLine: false,
  },
  {
    title: "送信時刻",
    keyword: "sendBegIntegerime",
    type: "nodeInLine",
    showLine: false,
  },
];

// const tableList2: ITkFakeTableLineProps[] = [
//   {
//     title: "帳票名称",
//     keyword: "formName",
//     requiredIcon: true,
//     inputProps: { maxLength: 85 },
//   },
//   {
//     title: "帳票概要",
//     keyword: "formSummary",
//     type: "text",
//   },
//   {
//     title: "帳票内容",
//     keyword: "detail",
//     type: "textarea",
//     requiredIcon: true,
//     inputProps: { maxLength: 1000 },
//   },
//   {
//     title: "プレビュー",
//     keyword: "preview",
//     type: "nodeInLine",
//   },
// ];

const schema = {
  address1: {
    required: TkPropertyMessageGet("TKMSG_SCR0044E"),
  },
  tempName: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
    maxLength: {
      value: 85,
      message: TkPropertyMessageGet("TKMSG_SCR0046E", "85"),
    },
  },
  procedureName: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
  },
  title: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
    maxLength: {
      value: 85,
      message: TkPropertyMessageGet("TKMSG_SCR0046E", "85"),
    },
  },
  text: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
    maxLength: {
      value: 1000,
      message: TkPropertyMessageGet("TKMSG_SCR0046E", "1000"),
    },
  },
  formName: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
    maxLength: {
      value: 85,
      message: TkPropertyMessageGet("TKMSG_SCR0046E", "85"),
    },
  },
  detail: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
    maxLength: {
      value: 1000,
      message: TkPropertyMessageGet("TKMSG_SCR0046E", "1000"),
    },
  },
};

export { tableList, schema };
